import React, { FC, ReactNode } from 'react'
import { Form } from 'rsuite'

import styles from '../../../../styles/MultiStepModal.module.less'

export interface InputWrapperProps {
  label: string
  subLabel?: string
  controlId: string
  className?: string
  children: ReactNode
  childrenContainerClassName?: string
  infoPopover?: ReactNode
  customErrorMessage?: ReactNode
  isCheckPicker?: boolean
}

const InputWrapper: FC<InputWrapperProps> = (props) => {
  const {
    isCheckPicker = false,
    controlId,
    label,
    subLabel,
    children,
    className,
    childrenContainerClassName,
    infoPopover = null,
    customErrorMessage = null,
  } = props

  return (
    <Form.Group
      controlId={isCheckPicker
        ? undefined : controlId} // Avoiding auto open of checkpicker on label click
      className={className}
    >
      {(label || subLabel) && (
        <Form.ControlLabel className={styles['input-label']}>
          {label}
          {' '}
          {infoPopover}
        </Form.ControlLabel>
      )}

      {subLabel && (
        <p className={styles['sub-input-label']}>
          {subLabel}
        </p>
      )}

      <div className={childrenContainerClassName}>
        {children}
      </div>

      {customErrorMessage}
    </Form.Group>

  )
}

export default InputWrapper
